import React, { useContext, useEffect, useState } from "react";
import { Outlet, useMatch, useParams, useLocation  } from 'react-router-dom';
// import 'aos/dist/aos.css';
import Header from '../../components/Header';
import { CookieBanner } from '../../components/CookieBanner';
const Wrap = () => {
  const [items, setItems] = useState([]);
  const [style, setStyle] = useState('');
  const [cp, setCP] = useState('');
  let location = useLocation();
  let header = <Header items={items} style={style} currentPath={cp}/>
  const useCurrentPath = () => {
    const id = useMatch('/:id');
    const idid = useMatch('/:id/:id');
    if (id !== null && id.params.id !== undefined) {
      return id.params.id;
    }
    if (idid !== null && idid.params.id !== undefined) {
      return idid.params.id;
    }
    return 'main';
  }
  const currentPath = useCurrentPath().toLowerCase();

  // триггерная анимация
  useEffect(() => {
    const animElements = document.querySelectorAll('[data-animate]');
    let observerArray = [];
    animElements.forEach((element, index) => {
      let threshold = element.dataset.animateThreshould === undefined ? 0 : element.dataset.animateThreshould;
      let rootMargin = element.dataset.animateOffset === undefined ? '-10%' : element.dataset.animateOffset;
      let duration = element.dataset.animateDuration === undefined ? '0.7' : element.dataset.animateDuration;
      let delay = element.dataset.animateDelay === undefined ? '0' : element.dataset.animateDelay;
      let ease = element.dataset.animateEase === undefined ? null : element.dataset.animateEase;
      let length = element.dataset.animateLength === undefined ? null : element.dataset.animateLength;
      
      if(delay !== '0'){
        element.style.transitionDelay = `${delay}s`;
      }
      if(duration !== '0.7'){
        element.style.transitionDuration = `${duration}s`;
      }
      if(ease !== null){
        element.style.transitionTimingFunction = ease;
      }
      if(length !== null){
        element.style.setProperty("--length", length);
      }
      
      let options = {
        threshold: threshold,
        rootMargin: `0% 100% ${rootMargin} 100%`
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add(`animate`);
            observer.unobserve(entry.target);
          }
        })
      }, options);

      observer.observe(element);
      observerArray.push(observer);
    });

    // навигация на страницах
    switch (currentPath) {
      case 'story-svetlana':
        setItems(['Начало пути', 'Наставничество', 'Руководство отделом продаж', 'Руководство департаментом']);
        setStyle('svetlana');
        break;
      // case 'story-alexandra':
      //   setItems(['Стипендия', 'Первые вызовы', 'Вакцинный проект и давление', 'Не просто работа']);
      //   setStyle('alexandra');
      //   break;
      // case 'story-felix':
      //   setItems(['Мечта', 'Стажировка', 'Работа в штате']);
      //   setStyle('felix');
      //   break;
      case 'story-evgenia':
        setItems(['Свобода выбирать путь', 'Ошибаться', 'Совмещать', 'Предлагать']);
        setStyle('evgenia');
        break;
      case 'story-dmitry':
        setItems(['Россия: начало', 'Китай', 'Россия: успехи', 'Россия: вызов','Германия']);
        setStyle('dmitry');
        break;
      case 'story-ekaterina':
        setItems(['Истоки', 'Уникальная система', 'От отдела до департамента']);
        setStyle('ekaterina');
        break;
      default:
        setItems([]);
        setStyle('');
        break;
    }
    setCP(currentPath);
    return () => {
      animElements.forEach((element, index) => {
        observerArray[index].unobserve(element);
      });
    }
  }, [currentPath]);


  switch (currentPath) {
    case 'main':
      header = null;
      break;
    default:
      break;
  }

  return (
    <>
      <div className="wrap">
        {header}
        <Outlet />
      </div>
      <CookieBanner />
    </>
  );

}

export default Wrap;
